import { useRecoilState } from "recoil";
import instance from "helpers/instance";
import { authAtom } from "state/recoil-root";

const useDataPermissionActions = () => {
  const [auth] = useRecoilState(authAtom);
  const headers = {
    Authorization: `Bearer ${auth?.access_token}`,
  };

  return {
    getDataPermissions,
    createDataPermission,
    updateDataPermission,
    patchDataPermissionStatus,
    getDelegates,
    createDelegate,
    patchDelegateStatus,
    getLocations,
    getChannels,
    getUnits,
    getShows,
    searchUsers,
  };

  function getDataPermissions(userId, page = 0, pageSize = 10, status = '') {
    const offset = page * pageSize;
    return instance({
      url: "report-service/v1/user-data-permissions",
      method: "GET",
      params: {
        user_id: userId,
        status: status !== '' && status !== '0' ? status : undefined,
        offset,
        limit: pageSize,
      },
      headers,
    });
  }

  function createDataPermission(data) {
    return instance({
      url: "report-service/v1/user-data-permissions",
      method: "POST",
      data,
      headers,
    });
  }

  function updateDataPermission(id, data) {
    return instance({
      url: `report-service/v1/user-data-permissions/${id}`,
      method: "PUT",
      data,
      headers,
    });
  }

  function patchDataPermissionStatus(id, status) {
    return instance({
      url: `report-service/v1/user-data-permissions/${id}/status`,
      method: "PATCH",
      data: { status },
      headers,
    });
  }

  function getDelegates(managerId, page = 0, pageSize = 10, status = '') {
    const offset = page * pageSize;
    return instance({
      url: "report-service/v1/user-data-permission-delegates",
      method: "GET",
      params: {
        manager_id: managerId,
        status: status !== '' && status !== '0' ? status : undefined,
        offset,
        limit: pageSize,
      },
      headers,
    });
  }

  function createDelegate(data) {
    return instance({
      url: "report-service/v1/user-data-permission-delegates",
      method: "POST",
      data,
      headers,
    });
  }

  function patchDelegateStatus(id, status) {
    return instance({
      url: `report-service/v1/user-data-permission-delegates/${id}/status`,
      method: "PATCH",
      data: { status },
      headers,
    });
  }

  function getLocations() {
    return instance({
      url: "management/v1/locations",
      method: "GET",
      params: { status: 1, offset: 0, limit: 500 },
      headers,
    });
  }

  function getChannels() {
    return instance({
      url: "management/v1/channels",
      method: "GET",
      params: { status: 1 },
      headers,
    });
  }

  function getUnits(channelId, search = '', offset = 0, limit = 20) {
    return instance({
      url: "management/v1/units",
      method: "GET",
      params: { channel_id: channelId, name: search || undefined, offset, limit },
      headers,
    });
  }

  function getShows() {
    return instance({
      url: "management/v1/shows",
      method: "GET",
      params: { status: 1, offset: 0, limit: 500 },
      headers,
    });
  }

  function searchUsers(query = "", offset = 0, limit = 50) {
    return instance({
      url: "usermanagement/v1/users",
      method: "GET",
      params: {
        offset,
        limit,
        email: query || null,
        role_ids: "",
        status: 1,
        sort_type: "",
        sort_field: "",
      },
      headers,
    });
  }
};

export { useDataPermissionActions };
